module.exports = __webpack_public_path__ + "assets/events_health_plain.ce6723f5.svg";